import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { KeyboardDatePicker } from "@material-ui/pickers";

import MakeAPICall from "../../apiCalls/common";

import appRoutes from "../../routes/appRoutes";

import {
  getTicketsApiRoute,
  getSupportStaffApiRoute,
  getTicketsWithFilterApiRoute,
  exportTicketsApiRoute
} from "../../apiRoutes";

import { getFormattedDate, converToUtc } from "../../utils/dateTimeHelper";
import {
  getMappedStatus,
  getDoctorInfoMapped,
  getPatientInfoMapped,
  sortData
} from "../../utils/commonMethods";

import Button from "../../components/button";
import Loader from "../../components/loader";
import TicketFilters from "../../containers/Tickets/ticketFilters";
import CustomModal from "../../components/modal";
import moment from "moment";
import searchFilterList from "../../constants/searchFilterList";
import CustomDataTableSearchByFilter from "../../components/datatable/customDataTableSearchByFilter";
import { setTicketCount } from "../../reduxStore/actions/serverConstants"

const ViewTicketPage = props => {
  let history = useHistory();

  const [startDate, setStartDate] = useState(moment().subtract(3, "month").startOf("day"));
  const [endDate, setEndDate] = useState(moment().add(7, 'days').endOf('day'));
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [currFilters, setCurrFilters] = useState({
    startDate: startDate?.toISOString(),
    endDate: endDate?.toISOString(),
    skip: 0,
    limit: 10
  });
  // const [staff, setStaff] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [showErrModal, setShowErrModal] = useState(false);
  const [errModalText, setErrModalText] = useState("");

  let tableHeaders = [
    {
      key: "caseNumber",
      value: "Ticket Number",
      customStyle: { maxWidth: "100px" }
    },
    { key: "dateReceived", value: "Date Received" },
    {key: "followUpDate", value: "Follow-Up"},
    { key: "doctor", value: "Doctor" },
    { key: "patient", value: "Patient" },
    { key: "subject", value: "Subject" },
    { key: "responsible", value: "Responsible" },
    { key: "status", value: "Status" }
  ];

  const goToEditPage = id => {
    history.push(appRoutes.editTicket + "/" + id);
  };

  const exportData = async () => {
    setIsProcessing(true);

    var formData = new FormData();
    formData.append("which", "ALL");

    if (startDate !== null && endDate !== null && startDate <= endDate) {
      formData.append("startDate", converToUtc(startDate));
      let dt = new Date(
        endDate.get("year"),
        endDate.get("month"),
        endDate.get("date") + 1,
        0,
        0,
        0
      ).toISOString();
      formData.append("endDate", converToUtc(dt));
    }

    await setApiCallParams({
      reqType: "POST",
      reqUrl: exportTicketsApiRoute,
      dataObj: formData,
      successCallback: async res => {
        setIsProcessing(false);
        var fileURL = res.data.data;
        var a = document.createElement("a");
        a.href = fileURL;
        a.target = "_blank";
        a.download = "Tickets.csv";
        document.body.appendChild(a); //create the link "a"
        a.click(); //click the link "a"
        document.body.removeChild(a); //remove the link "a"
      },
      failureCallback: err => {
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  // get the staff list
  // const getSupportStaffData = async () => {
  //   await setApiCallParams({
  //     reqType: "GET",
  //     reqUrl: getSupportStaffApiRoute,
  //     params: {
  //       skip: 0,
  //       limit: 0
  //     },
  //     successCallback: async res => {
  //       const staffList = [];
  //       await res.data.data.staffs.forEach(staff => {
  //         if (staff.isBlocked === false) {
  //           staffList.push({
  //             id: staff._id,
  //             name: staff.firstName + " " + staff.lastName
  //           });
  //         }
  //       });
  //       setStaff(staffList);
  //     },
  //     failureCallback: err => {}
  //   });
  // };

  // get tickets data
  const getTicketsData = async () => {
    let params = Object.assign({}, currFilters);
    let isCurrUser = false;
    if (
      (currFilters.responsible === undefined ||
        currFilters.responsible === null) &&
      props.user &&
      props.user.userType === "SUPPORT_STAFF"
    ) {
      params.responsible = props.user._id;
      isCurrUser = true;
    }

    let api = getTicketsApiRoute;

    if (currFilters.text && currFilters.text.length > 0) {
      api = getTicketsWithFilterApiRoute;
      if (isCurrUser === true) {
        delete params.responsible;
      }
    } else {
      delete params.text;
    }

    setIsProcessing(true);

    await setApiCallParams({
      reqType: "GET",
      reqUrl: api,
      params: params,
      successCallback: async res => {
        setIsProcessing(false);
        setTicketsList(res.data.data);
        if (res.data && res.data.data && res.data.data.adminActionCount) {
          if (props.user.userType !== "SUPPORT_STAFF") {
            let count = 0;
            for (const userId in res.data.data.adminActionCount) {
              count += res.data.data.adminActionCount[userId];
            }
            props.setTicketCount(count);
          } else {
            props.setTicketCount(res.data.data.adminActionCount[props.user?._id] || 0);
          }
        }
      },
      failureCallback: err => {
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  useEffect(() => {
    async function getData() {
      await getTicketsData();
    }
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currFilters]);

  // set ticket list data
  const setTicketsList = data => {
    let list = [];

    data.tickets.forEach(column => {
      let doct = "";
      if (column.doctorId === undefined || column.doctorId === null) {
        if (column.topic === "DOCTOR") {
          doct = "Doctor";
        } else if (column.topic === "PATIENT") {
          doct = "Patient";
        } else {
          doct = "Other";
        }
      } else {
        doct = getDoctorInfoMapped(column.doctorId);
      }

      let pat = "";
      if (column.patientId === undefined || column.patientId === null) {
        pat = column.name.toString().replace("//", "|");
      } else {
        pat = getPatientInfoMapped(column.patientId);
      }

      let status = getMappedStatus(column.status);

      let resp = "";

      if (column.responsible) {
        if(column.responsible.firstName === "System" && column.responsible.lastName === "System") {
          resp = "Instant Consult";
        } else {
          resp =
            (column.responsible.firstName ? column.responsible.firstName : "NA") +
            " " +
            (column.responsible.lastName ? column.responsible.lastName : "NA");
        }
      } else {
        resp = " ";
      }

      list.push({
        id: column._id,
        caseNumber: column.caseNumber,
        doctor: doct,
        patient: pat,
        responsible: resp,
        status: status,
        dateReceived: getFormattedDate(column.dateReceived),
        followUpDate: column.followUpDate ? getFormattedDate(column.followUpDate) : '-',
        subject: column.subject,
        onHoldDate: column.onHoldDate ? getFormattedDate(column.onHoldDate) : ""
      });
    });

    // set the ticket list
    setTickets(list);
    setTotalRecords(data.count);
  };

  const setTopFilters = filters => {
    let newFilter = Object.assign({}, currFilters);
    newFilter.responsible = filters.responsible;
    newFilter.status = filters.status;
    newFilter.doctorId = filters.doctorId;

    setCurrFilters(newFilter);
  };

  const setTableFilters = filters => {
    let newFilter = Object.assign({}, currFilters);
    newFilter.limit = filters.limit;
    newFilter.text = filters.text;
    newFilter.skip = filters.skip;
    newFilter.filterType = filters.filterType;
    setCurrFilters(newFilter);
  };

  const sortTableDataByColumn = SelColumn => {
    let sortedData = sortData(SelColumn.column, SelColumn.order, tickets);
    setTickets(sortedData);
  };

  const handleStartDateChange = date => {
    setStartDate(date);
    setCurrFilters({
      ...currFilters,
      startDate: date.toISOString()
    })
  };

  const handleEndDateChange = date => {
    setEndDate(date);
    setCurrFilters({
      ...currFilters,
      endDate: date.toISOString()
    })
  };

  return (
    <div className="view-ticket-container">
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <CustomModal
          useOneButton={true}
          cancelText="OKAY"
          openModal={showErrModal}
          cancelEvent={() => {
            setShowErrModal(false);
            setErrModalText("");
          }}
          modalBodyContent={<p className="text-center mb-0">{errModalText}</p>}
        />
        <div className="d-flex flex-row flex-wrap justify-content-between">
          <h3>Tickets</h3>
          <div className="d-flex flex-row align-items-end">
            <Button clickEvent={exportData} title="Export to CSV"></Button>
          </div>
        </div>

        <div className="d-flex flex-row flex-wrap align-items-end">
          <span className="flex-grow-1" />
            <KeyboardDatePicker
              name="startDate"
              style={{ width: "135px" }}
              autoOk
              variant="inline"
              mask="__-__-____"
              format="DD-MM-YYYY"
              label="Start Date"
              value={startDate}
              onChange={date => handleStartDateChange(date)}
            />
            <KeyboardDatePicker
              name="endDate"
              className="mr-2"
              style={{ width: "135px", marginLeft: "20px" }}
              autoOk
              variant="inline"
              mask="__-__-____"
              format="DD-MM-YYYY"
              label="End Date"
              value={endDate}
              onChange={date => handleEndDateChange(date)}
            />

            <TicketFilters doctorList={props.doctorList} staffList={props.supportStaff} setFilters={setTopFilters} />
        </div>
        <CustomDataTableSearchByFilter
          disbleAll={true}
          disableSearchText={false}
          searchColumnText="Search by:"
          searchFilterList={searchFilterList.ticketsSearchFilterList}
          totalRecords={totalRecords}
          headers={tableHeaders}
          setFilters={setTableFilters}
          sortData={sortTableDataByColumn}
          tabFilters={currFilters}
        >
          {tickets.length > 0 &&
            tickets.map((ticket, index) => (
              <tr
                key={index}
                onClick={e => {
                  e.preventDefault();
                  goToEditPage(ticket.id);
                }}
                style={{
                  backgroundColor: ticket.status === "Support Action Required" ? "#ff8fec" : ""
                }}
              >
                <td style={{ maxWidth: "100px" }}>{ticket.caseNumber}</td>
                <td>{ticket.dateReceived}</td>
                <td>{ticket.followUpDate}</td>
                <td>{ticket.doctor}</td>
                <td>{ticket.patient}</td>
                <td>{ticket.subject}</td>
                <td>{ticket.responsible}</td>
                <td>
                  {ticket.status === "On Hold" ? (
                    <div>
                      {ticket.status} <br /> {ticket.onHoldDate}
                    </div>
                  ) : (
                    ticket.status
                  )}
                </td>
              </tr>
            ))}
        </CustomDataTableSearchByFilter>
        {/* API Call */}
        <MakeAPICall apiParam={apiCallParams} />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.auth.user,
  supportStaff: state.serverConstants.supportStaff,
  doctorList: state.serverConstants.doctorAndNurseList,
});

const mapDispatchToProps = dispatch => ({
  setTicketCount: data => dispatch(setTicketCount(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewTicketPage);
